/**
 * Resources Archive Filters.
 *
 * @type {Object}
 */

const DtkResources = {
	checkedCountSpan: document.querySelector( '.listing-filters-title .count' ),
	checkboxGroups: document.querySelectorAll( '.filter-lists' ),
	globalClearBtn: document.querySelector( '.clear-all-filter' ),

	/**
	 * Initialize.
	 *
	 * @return {void}
	 */
	init() {
		this.toggleListItems();
		this.toggleMobileFilters();
		this.filterCount();
		this.filterPosts();
		this.loadMorePosts();
	},

	/**
	 * Toggle term list.
	 *
	 * @return {void} Toggle the list items on button click.
	 */
	toggleListItems() {
		const filterMore = document.querySelectorAll( '.filter-more' );

		if ( 0 < filterMore?.length ) {
			filterMore.forEach( ( moreBtn ) => {
				moreBtn?.addEventListener( 'click', () => {
					moreBtn.classList.toggle( 'active' );
					moreBtn.previousElementSibling?.classList?.toggle( 'view-all' );

					if ( moreBtn.classList.contains( 'active' ) ) {
						moreBtn.setAttribute( 'aria-expanded', 'true' );
					} else {
						moreBtn.setAttribute( 'aria-expanded', 'false' );
					}
				} );
			} );
		}
	},

	toggleMobileFilters() {
		const filterWrap = document.querySelector( '.filter-wrapper' );
		if ( ! filterWrap ) return;
		
		const mobileBtn = document.getElementById( 'trigger-toggle-filter' );
		mobileBtn?.addEventListener( 'click', () => {
			filterWrap.classList.toggle( 'is-visible' );
		} );

		// Remove class on tablet and desktop view.
		window.addEventListener( 'resize', () => {
			if ( 767 < window.innerWidth ) {
				filterWrap.classList.remove( 'is-visible' );
			}
		} );

		// Close the filter dropdown on esc key click.
		document.addEventListener( 'keydown', ( event ) => {
			if ( 'Escape' === event.key  ) {
				filterWrap.classList.remove( 'is-visible' );
			}
		} );

		// Close the filter dropdown if click outside.
		document.addEventListener( 'click', ( event ) => {
			if ( filterWrap.classList?.contains( 'is-visible' ) ) {
				if (
					! filterWrap.contains( event.target ) &&
					! document.querySelector( '.mobile-filter-button' )?.contains( event.target ) &&
					! document.querySelector( '.listing-filters-title' )?.contains( event.target )
				) {
					filterWrap.classList.remove( 'is-visible' );
				}
			}
		} );
	},

	/**
	 * Update checkbox checked count.
	 *
	 * @param {Object} checkedCountSpan Count span.
	 *
	 * @return {void}
	 */
	updateCheckedCount( checkedCountSpan ) {
		if ( ! checkedCountSpan ) return

		const checkboxes = document.querySelectorAll( '.filter-wrapper .option' );
		if ( ! checkboxes ) return

		const checkedCount = Array.from( checkboxes )?.filter( ( checkbox ) => checkbox.checked ).length;
		checkedCountSpan.textContent = checkedCount;

		if ( 0 !== checkedCount ) {
			this.globalClearBtn.classList.add( 'active' );
		} else {
			this.globalClearBtn.classList.remove( 'active' );

			// Remove active state for individual clear button.
			document.querySelectorAll( '.filter-wrapper .clear-filter' )?.forEach( ( clearBtn ) => {
				clearBtn.classList.remove( 'active' );
			} );
		}

		// @todo: Uncomment below code if need to close dropdown.

		// Close the filter dropdown on count update.
		// if ( document.querySelector( '.filter-wrapper' ).classList.contains( 'is-visible' ) && window.innerWidth < 768 ) {
		// 	document.querySelector( '.filter-wrapper' ).classList.remove( 'is-visible' );
		// }
	},

	/**
	 * Handle filter count and clear filter on button.
	 *
	 * @return {void}
	 */
	filterCount() {
		const checkedTerms = this.getCheckedTerms();

		this.checkboxGroups?.forEach( ( group ) => {
			const checkboxesAll = group.querySelectorAll( '.option' );
			const clearBtn = group.querySelector( '.clear-filter' );

			if ( checkedTerms.hasOwnProperty( clearBtn?.getAttribute( 'data-clear' ) ) ) {
				clearBtn.classList.add( 'active' );
			}

			clearBtn.addEventListener( 'click', () => {
				const listToClear = clearBtn.dataset.clear;
				const checkboxes = document.getElementById( listToClear )?.querySelectorAll( '.option' );

				checkboxes?.forEach( ( checkbox ) => {
					if ( true === checkbox.checked ) {
						checkbox.checked = false;
						clearBtn.classList.remove( 'active' );
					}
				} );

				this.updateCheckedCount( this.checkedCountSpan );
				this.loadCheckedPosts();
			} );

			checkboxesAll?.forEach( ( checkbox ) => {
				checkbox.addEventListener( 'change', () => {
					const checkedCount = Array.from( checkboxesAll ).filter( ( checkboxField ) => checkboxField.checked ).length;

					if ( 0 !== checkedCount ) {
						clearBtn.classList.add( 'active' );
					} else {
						clearBtn.classList.remove( 'active' );
					}

					this.updateCheckedCount( this.checkedCountSpan );
				} );
			} );

			this.updateCheckedCount( this.checkedCountSpan );
		} );

		this.globalClearBtn?.addEventListener( 'click', () => {
			this.checkboxGroups?.forEach( ( group ) => {
				const checkboxes = group.querySelectorAll( '.option' );
				checkboxes.forEach( ( checkbox ) => checkbox.checked = false );
				this.updateCheckedCount( this.checkedCountSpan );
			} );
			this.globalClearBtn?.classList.remove( 'active' );
			this.loadCheckedPosts();
		} );
	},

	/**
	 * Handle filter load post.
	 *
	 * @return {void}
	 */
	filterPosts() {
		this.checkboxGroups?.forEach( ( group ) => {
			const checkboxesAll = group.querySelectorAll( '.option' );

			checkboxesAll?.forEach( ( checkbox ) => {
				checkbox.addEventListener( 'change', ( e ) => {
					e.preventDefault();

					this.loadCheckedPosts();
				} );
			} );
		} );
	},

	/**
	 * Load filtered post with pagination and add content to page.
	 *
	 * @param {number}  page   Current page.
	 * @param {boolean} append Append or replace.
	 */
	loadCheckedPosts( page = 1, append = false ) {
		const taxonomy = this.getCheckedTerms();

		if ( taxonomy && '0' === window.dtkDealerResource.is_main_archive ) {
			if ( taxonomy[ window.dtkDealerResource.current_term.taxonomy ] ) {
				taxonomy[ window.dtkDealerResource.current_term.taxonomy ].push( window.dtkDealerResource.current_term.slug );
			} else {
				taxonomy[ window.dtkDealerResource.current_term.taxonomy ] = [ window.dtkDealerResource.current_term.slug ];
			}
		}


		const currentPostType = window.dtkDealerResource.current_post;


		const body = {
			action: 'dtk_post_filter_ajax_handler',
			nonce: dtkDealerResource.dtk_post_filter_nonce, // eslint-disable-line no-undef
			taxonomy,
			currentPostType,
			page: parseInt( page )
		};

		// If the page is not CPT archive page then we handle it through different ajax method.
		if ( '0' === window.dtkDealerResource?.is_main_archive ) {
			body.action = 'dtk_post_taxonomy_filter_ajax_handler';

			// body.taxonomy data does not uniquely identify the taxonomy and term of the current page.
			// To get the current taxonomy and term, we utilize 'page_taxonomy' and 'page_term'.
			body.page_taxonomy = window.dtkDealerResource.current_term.taxonomy; // eslint-disable-line camelcase
			body.page_term = window.dtkDealerResource.current_term.slug; // eslint-disable-line camelcase
		}

		jQuery.ajax( { // eslint-disable-line no-undef
			method: 'POST',
			url: dtkDealerResource.ajaxurl, // eslint-disable-line no-undef
			data: body,
			statusCode: {
				200: ( response ) => {
					if ( 'object' === typeof response && response.success ) {

						const postResult = document.querySelector( '.post-result' );
						if ( append ) {
							postResult.innerHTML += response.data.content;
						} else {
							postResult.innerHTML = response.data.content;
							this.updateURLPath( taxonomy );
						}

						const loadMoreButton = document.querySelector( '.load-posts button' );
						const hasMorePosts = response.data.has_more_posts;

						if ( hasMorePosts ) {
							loadMoreButton.classList.remove( 'hidden' );
							loadMoreButton.disabled = false;
							/* eslint-disable camelcase */
							loadMoreButton.dataset.current_count = response.data.count;
							loadMoreButton.dataset.next_paged = response.data.paged;
							/* eslint-enable camelcase */
						} else {
							loadMoreButton.classList.add( 'hidden' );
							loadMoreButton.disabled = true;
						}

						// If no posts were loaded, show a message
						if ( '' === response.data.content.trim() ) {
							postResult.innerHTML = '<p class="no-posts-message">No posts found</p>';
						}
					}

					// Re-enable the load more button.
					const loadMoreButton = document.querySelector( '.load-posts button' );
					loadMoreButton?.removeAttribute( 'disabled' );
				}
			}
		} );
	},

	/**
	 * Update URL path by selected Categories.
	 *
	 * @param {Object} category All selected terms by taxonomy.
	 */
	updateURLPath( category = {} ) {
		window.history.pushState( {}, '', this.getURLPath( category ) );
	},

	/**
	 * Gives URL path from selected Categories.
	 *
	 * @param {Object} category All selected terms by taxonomy.
	 *
	 * @return {string} URL.
	 */
	getURLPath( category = {} ) {
		const slug = [];
		const query_param_prefix = window?.dtkDealerResource?.query_param_prefix; // eslint-disable-line camelcase
		let urlPath = window.location.pathname; // phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment

		/**
		 * Generate URL from selected filter terms.
		 *
		 * Input:
		 * {
		 *     "category": [
		 *         "news",
		 *         "updates",
		 *     ]
		 * }
		 *
		 * Output: /resources/?category=news,updates
		 */
		Object.keys( category )?.forEach( ( key ) => {
			slug.push( query_param_prefix + key + '=' + category[ key ].join( ',' ) );
		} );

		if ( slug.length ) {
			urlPath = urlPath + '?' + slug.join( '&' );
		}

		return urlPath;
	},

	/**
	 * Get checked terms from checkboxes.
	 *
	 * @return {Object} Object with array terms.
	 */
	getCheckedTerms() {
		const selectedTerm = {};

		this.checkboxGroups?.forEach( ( group ) => {
			const checkboxesChecked = group.querySelectorAll( '.option:checked' );

			checkboxesChecked?.forEach( ( checkbox ) => {
				const name = checkbox.name;
				const value = checkbox.value;

				if ( ! selectedTerm[ name ] ) {
					selectedTerm[ name ] = [];
				}

				selectedTerm[ name ].push( value );
			} );
		} );

		return selectedTerm;
	},

	/**
	 * DOM event loader.
	 */
	loadMorePosts() {
		const loadMoreButton = document.querySelector( '.load-posts button' );

		loadMoreButton?.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			loadMoreButton?.setAttribute( 'disabled', 'true' );

			const nextPaged = ( 'undefined' === typeof e.target.dataset.next_paged ) ? 2 : e.target.dataset.next_paged;
			this.loadCheckedPosts( nextPaged, true );
		} );
	}
};

export default DtkResources;
